<template>
    <div>

        <div class="bg-white shadow-lines sm:shadow-dreamy">

            <a id="step-delivery" class="flex px-8 py-8 justify-between items-center" href="" @click.prevent="stepChange">
                <span class="w-8 mr-8">
                    <template v-if="complete">
                        <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#08A818"/><path d="M24.338 5.192L9.953 19.577l-5.286-5.285a.656.656 0 00-.928 0l-1.547 1.546a.656.656 0 000 .929l7.297 7.296a.656.656 0 00.928 0L26.813 7.667a.656.656 0 000-.928l-1.547-1.547a.656.656 0 00-.928 0z" fill="#fff"/></svg>
                    </template>
                    <template v-else>
                        <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#4A96D2"/><path d="M12.91 16.02h1.84c1.24 0 1.92.68 1.92 1.82 0 1.06-.68 1.82-1.76 1.82-1.2 0-1.76-.82-1.8-1.78h-2.74c0 2.02 1 4.38 4.54 4.38 2.74 0 4.62-1.82 4.62-4.48s-1.58-3.82-3.48-4.06l2.86-3.08V8.16h-8.04v2.5h4.82l-2.78 3.2v2.16z" fill="#4A96D2"/></svg>
                    </template>
                </span>
                <span
                    :class="{ 'text-gray-300': disabled, 'text-black': !disabled }"
                    class="w-full text-xl font-platform tracking-wider"
                >Kontaktuppgifter och leveranssätt</span>
                <span v-if="! open && ! disabled">
                    <span href="#" class="text-sm text-gray-400 underline hover:text-black">
                        Ändra
                    </span>
                </span>
            </a>

            <!-- Expanded -->
            <ValidationObserver ref="form">
                <div class="pb-4 px-4 sm:pb-8 sm:px-8" v-if="open && ! loading">
                <div class="text-lg text-blue-400 mb-3">Dina kontaktuppgifter</div>

                <template v-if="!form.contact.skip_national_identification_number">
                    <div class="text-sm text-gray-400 mb-3">Spara tid genom att fylla i ditt personnummer, då hämtas dina uppgifter automatiskt.</div>
                    <div class="relative">
                        <div class="absolute right-0 z-10 mr-6 text-sm" style="margin-top: 14px">
                            <a class="text-gray-400 underline hover:text-black" href="" @click.prevent="form.contact.skip_national_identification_number = true">Skippa</a>
                        </div>
                        <card-input class="mb-3" label="Personnummer" v-model="form.contact.national_identification_number"></card-input>
                    </div>
                </template>


                <card-input class="mb-3" label="E-post" v-model="form.contact.email" rules="required" />
                <card-input class="mb-6" label="Telefon" v-model="form.contact.phone" rules="required" />

                <!-- Name & address fields if we don't fill national identification number -->
                <template v-if="form.contact.skip_national_identification_number">
                        <div class="border-t-2 border-blue-400 border-dashed pt-4 mb-2">
                        <div class="text-sm text-gray-400 mb-5 leading-relaxed" v-if="sparEnabled">
                            Eftersom du skippat personnummer behöver vi din adress. <a class="text-blue-600 underline" href="" @click.prevent="form.contact.skip_national_identification_number = false">Vill du fylla i personnummer istället?</a>
                        </div>
                        <div class="flex">
                            <card-input class="mb-3 mr-1 w-1/2" label="Förnamn" v-model="form.contact.first_name" rules="required" />
                            <card-input class="mb-3 ml-1 w-1/2" label="Efternamn" v-model="form.contact.last_name" rules="required" />
                        </div>
                        <card-input class="mb-3" label="Address" v-model="form.contact.line1" rules="required" />
                        <div class="flex">
                            <card-input class="mb-3 mr-1 w-1/2" label="Postnummer" v-model="form.contact.zip" rules="required" />
                            <card-input class="mb-3 ml-1 w-1/2" label="Ort" v-model="form.contact.city" rules="required" />
                        </div>
                    </div>
                </template>

                <div class="text-lg text-blue-400 mb-3">Leveranssätt</div>

                <CardRadio class="mb-3" name="method" v-model="form.delivery.method" checked-value="digital">
<!--                    {{ product.name }} digitalt-->
                    Digitalt gåvobevis
                    <span class="block text-sm text-gray-400">Levereras till din e-post som PDF</span>
                </CardRadio>

                <CardRadio class="mb-3" name="method" v-model="form.delivery.method" checked-value="print">
<!--                    {{ product.name }} tryckt-->
                    Tryckt gåvobevis
                    <span class="block text-sm text-gray-400 font-bold">Leveranstid 7 arbetsdagar</span>
                    <span class="block text-sm text-gray-400">Levereras till valfri adress inom Sverige</span>
                </CardRadio>

                <!-- Only for print delivery method -->
                <div
                    v-if="form.delivery.method === 'print' && product.type === 'memorial_card'"
                    style="margin-left: 25px"
                    class="mb-8"
                >
                    <vc-date-picker
                        class="w-64 border-green-400"
                        locale="sv"
                        v-model="form.delivery.funeral_at"
                    >
                        <div
                            class='field'
                            slot-scope='{ inputValue, updateValue }'>
                            <div class="control has-icons-left has-icons-right">
                                <card-input
                                    class="mb-3 w-64"
                                    :value="inputValue"
                                    @change='updateValue($event.target.value)'
                                    label="Begravningsdatum"
                                />
                            </div>
                        </div>
                    </vc-date-picker>
                </div>

                <template v-if="form.delivery.method === 'print'">
                    <div class="text-lg text-blue-400 mb-2">Leveransadress</div>

                    <card-radio class="mb-3" name="location" v-model="form.delivery.location" checked-value="home">
                        <span v-if="! form.contact.skip_national_identification_number">
                            Min folkbokföringsadress
                            <template v-if="form.contact.national_identification_number">
                                ({{ form.contact.national_identification_number }})
                            </template>
                        </span>
                        <span v-else-if="form.contact.line1 && form.contact.zip && form.contact.city">{{ form.contact.line1 }}, {{ form.contact.zip }}, {{ form.contact.city }}</span>
                        <span v-else>Hem</span>
                    </card-radio>

                    <template v-if="product.type === 'memorial_card'">
                        <card-radio class="mb-3" name="location" v-model="form.delivery.location" checked-value="funeral_home">Begravningsbyrå</card-radio>
                    </template>

                    <card-radio class="mb-6" name="location" v-model="form.delivery.location" checked-value="address">Valfri adress inom Sverige</card-radio>

                    <!-- Funeral home -->
                    <template v-if="form.delivery.location === 'funeral_home'">
                        <card-input class="mb-3" label="Begravningsbyrå" v-model="form.delivery.funeral_home" rules="required"></card-input>
                    </template>

                    <!-- Custom address -->
                    <template v-if="form.delivery.location === 'address'">
                        <card-input class="mb-3" label="Namn" v-model="form.delivery.to" rules="required"></card-input>
                    </template>

                    <!-- Funeral home & Custom address -->
                    <template v-if="form.delivery.location === 'address' || form.delivery.location === 'funeral_home'">
                        <card-input class="mb-3" label="Adress" v-model="form.delivery.line1" rules="required"></card-input>
                        <div class="flex">
                            <card-input class="mb-3 mr-1 w-1/2" label="Postnummer" v-model="form.delivery.zip" rules="required" />
                            <card-input class="mb-3 ml-1 w-1/2" label="Ort" v-model="form.delivery.city" rules="required" />
                        </div>
                    </template>
                </template>

                <card-checkbox class="mb-10 mt-4" v-model="form.consent" checked-value="true">Jag godkänner Barndiabetsfondens <a class="text-black" href="https://www.barndiabetesfonden.se/mer/integritetspolicy/" target="_blank">integritetspolicy</a></card-checkbox>

                <template v-if="errors">
                    <div class="bg-red-400 px-8 py-2 mb-6 rounded-tl rounded text-white text-base">
                        <div v-for="(error, k) in errors" class="flex items-center py-2">
                            <div class="mr-3"><svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11" stroke="#fff" stroke-width="2"/><circle cx="12" cy="18" r="1.5" fill="#fff"/><path d="M10.607 5.996a1.397 1.397 0 112.786 0L12.75 15h-1.5l-.643-9.004z" fill="#fff"/></svg></div>
                            <div v-if="k === 'contact.national_identification_number'">
                                Vi kan inte hämta dina uppgifter från ditt personnummer.<br><br><a href="" @click.prevent="skipUsingPersonalIdentificationNumber" class="underline">Klicka här för att fylla i din adress</a>
                            </div>
                            <div v-else>{{ error[0] }}</div>
                        </div>
                    </div>
                </template>

                <div class="text-center mb-4">
                    <card-button @click="next" :loading="saving">Till betalning</card-button>
                </div>
            </div>
            </ValidationObserver>
        </div>

    </div>
</template>

<script>
    import CardInput from "./CardInput"
    import CardRadio from "./CardRadio"
    import CardCheckbox from "./CardCheckbox"
    import { ValidationObserver } from 'vee-validate'
    import CardButton from "./CardButton"

    export default {
        name: "Delivery",
        components: {CardButton, CardCheckbox, CardRadio, CardInput,ValidationObserver},
        props: {
            open: {type: Boolean, default: false},
            loading: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            sparEnabled: {type: Boolean, default: false},
            form: {},
            product: {},
            errors: {},
        },
        data() {
            return {
                complete: false,
                saving: false,
            }
        },
        watch: {
            open: function(newValue) {
                this.saving = !newValue
            },
        },
        created() {
            if (! this.sparEnabled) {
                this.form.contact.skip_national_identification_number = true
            }
        },
        methods: {
            skipUsingPersonalIdentificationNumber() {
                this.form.contact.skip_national_identification_number = true
                this.form.contact.national_identification_number = null
                this.sparEnabled = false
                this.errors = null
            },
            stepChange() {
                if (!this.disabled) {
                    this.$emit('step', 'delivery')
                }
            },
            next() {
                if (! this.form.consent) {
                    alert('Du måste godkänna villkoren för att fortsätta')

                    return
                }

                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.saving = true
                        this.complete = true
                        this.$emit('completed', {
                            step: 'delivery',
                            error: (data) => {
                                this.errors = data.data.errors
                                this.saving = false
                            }
                        })
                    }
                })
            }
        }
    }
</script>